import { render, staticRenderFns } from "./AccountItemTables.vue?vue&type=template&id=55dbdf16&"
import script from "./AccountItemTables.vue?vue&type=script&lang=js&"
export * from "./AccountItemTables.vue?vue&type=script&lang=js&"
import style0 from "./AccountItemTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports